import { z } from 'zod';

import {
	zenDeskArticleSchema,
	zenDeskArticlesSchema,
	zenDeskCategoriesSchema,
	zenDeskCategorySchema,
} from 'services/helpcentre';

export const freeformZenDeskCategoriesSchema = z.object({
	type: z.literal('ZenDeskCategories'),
	controlData: zenDeskCategoriesSchema.optional(),
});

export const freeformZenDeskSectionsByCategorySchema = z.object({
	title: z.string().optional(),
	type: z.literal('ZenDeskSectionsByCategory'),
	controlData: z
		.array(
			zenDeskCategorySchema.extend({
				sectionArticles: zenDeskArticlesSchema.optional(),
			})
		)
		.optional(),
});

export const freeformZenDeskArticleSchema = z.object({
	type: z.literal('ZenDeskArticle'),
	controlData: zenDeskArticleSchema.optional(),
});

export const freeformZenDeskSearchResultsSchema = z.object({
	type: z.literal('ZenDeskSearchResults'),
	controlData: zenDeskArticlesSchema.optional(),
});

export const richtextSchema = z.object({
	type: z.literal('RichText'),
	body: z.string(),
	controlData: z.unknown().optional(),
});

export const embedSchema = z.object({
	type: z.literal('Embed'),
	script: z.string(),
	controlData: z.unknown().optional(),
});

export const accordionItemSchema = z.object({
	title: z.string(),
	description: z.string(),
	controlData: z.unknown().optional(),
});

export const accordionSchema = z.object({
	type: z.literal('Accordion'),
	id: z.string(),
	heading: z.string(),
	items: z.array(accordionItemSchema),
	controlData: z.unknown().optional(),
});

export const relatedArticlesSchema = z.object({
	type: z.literal('RelatedArticles'),
	title: z.string(),
	data: z.array(
		z.object({
			title: z.string(),
			url: z.string(),
		})
	),
	controlData: z.unknown().optional(),
});
